import { clsx } from 'clsx';

type SkeletonProps = {
  className?: string;
};

export const Skeleton = ({ className }: SkeletonProps) => (
  <div className={clsx('animate-pulse rounded-md bg-border', className)} />
);

// A single card-shaped skeleton matching the <Card> component's padding and border
export const CardSkeleton = ({ lines = 2 }: { lines?: number }) => (
  <div className="rounded-lg border border-border bg-surface p-4 md:p-6">
    <Skeleton className="mb-3 h-4 w-2/5" />
    {Array.from({ length: lines }).map((_, i) => (
      <Skeleton key={i} className={clsx('mb-2 h-3', i === lines - 1 ? 'w-3/5' : 'w-full')} />
    ))}
  </div>
);

// Stack of n card skeletons — used for list-style pages
export const CardListSkeleton = ({ count = 3, lines = 2 }: { count?: number; lines?: number }) => (
  <>
    {Array.from({ length: count }).map((_, i) => (
      <CardSkeleton key={i} lines={lines} />
    ))}
  </>
);

// Grid of card image skeletons — used for CardsPage / CardCollection
export const CardGridSkeleton = ({ count = 12 }: { count?: number }) => (
  <div className="grid grid-cols-3 gap-3 pt-4 sm:grid-cols-4">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="grid gap-2">
        <Skeleton className="aspect-[10/14] w-full rounded-lg" />
        <Skeleton className="mx-auto h-3 w-3/4" />
      </div>
    ))}
  </div>
);

// Generic CMS page skeleton — title + prose lines
export const StorySkeleton = () => (
  <div className="grid gap-6">
    <Skeleton className="mx-auto h-5 w-2/5" />
    <div className="grid gap-2">
      <Skeleton className="h-3 w-full" />
      <Skeleton className="h-3 w-full" />
      <Skeleton className="h-3 w-full" />
      <Skeleton className="h-3 w-4/5" />
    </div>
  </div>
);
